// Global messages service for composing emails from anywhere
export interface ComposeEmailData {
  to?: string;
  subject?: string;
  body?: string;
  linkTo?: { type: "client" | "prospect"; id: number };
}

class MessagesService {
  private composeCallback: ((data: ComposeEmailData) => void) | null = null;

  onCompose(callback: (data: ComposeEmailData) => void) {
    this.composeCallback = callback;
  }

  compose(data: ComposeEmailData) {
    if (this.composeCallback) {
      this.composeCallback(data);
    }
  }

  clearCallback() {
    this.composeCallback = null;
  }
}

export const messagesService = new MessagesService();

